export default __webpack_public_path__ + "static/Logo_Reykjavik-Excursions-2280f61a8e137d5d37cfd5ab7e9b43b6.jpg";